export default "__VITE_ASSET__VU7ncbB7__"